var config = SETTINGS

export default config



//////////////////
// WEBPACK FOOTER
// ./settings/index.js
// module id = null
// module chunks = 